// extracted by mini-css-extract-plugin
module.exports = {"body":"graphs_body__1IvOG","chip":"graphs_chip__VKH5K"};